import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Header } from "../components/Header";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { Loader2, Users, ArrowRight } from "lucide-react";

export default function JoinSession() {
  const { code } = useParams();
  const navigate = useNavigate();
  const { t } = useAuth();
  const [session, setSession] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/sessions/code/${code}`).then(({ data }) => setSession(data)).catch(() => setError(true));
  }, [code]);

  return (
    <div className="min-h-screen">
      <Header />
      <main className="max-w-lg mx-auto px-5 sm:px-8 py-20">
        {error ? (
          <div className="card-amt p-10 text-center" data-testid="join-error">
            <p style={{ color: "var(--text-dim)" }}>{t("invalid_session")}</p>
          </div>
        ) : !session ? (
          <div className="flex justify-center py-16"><Loader2 className="animate-spin gold-text" size={30} /></div>
        ) : (
          <div className="card-amt p-10 text-center animate-fade-up" style={{ opacity: 0 }} data-testid="join-card">
            <div className="w-14 h-14 mx-auto rounded-sm flex items-center justify-center mb-6" style={{ background: "rgba(201,165,87,0.12)" }}>
              <Users className="gold-text" size={26} />
            </div>
            <p className="text-xs uppercase tracking-[0.25em] mb-2" style={{ color: "var(--gold)" }}>{t("join_title")}</p>
            <h1 className="font-heading text-3xl mb-2" style={{ color: "var(--text)" }}>{session.title}</h1>
            <p className="text-sm mb-8" style={{ color: "var(--text-dim)" }}>{t("join_sub")}</p>
            <button
              data-testid="join-start-btn"
              onClick={() => navigate(`/test?session=${session.code}`)}
              className="btn-gold w-full py-3.5 inline-flex items-center justify-center gap-2"
            >
              {t("join_start")} <ArrowRight size={18} />
            </button>
          </div>
        )}
      </main>
    </div>
  );
}
